<template>
    <div>
        <rkm-data-table
            :disabled-button-search="true"
            :fields="fields"
            :repository="repositories.solicitacao"
            :tbody-tr-class="rowClass"
            class="solicitacao"
            ref="DataTable"
            sort-by="nome"
        >
            <template v-slot:cell(nome)="{item}">
                {{ item.nome }}

                <template v-if="item.nomeSocial">
                    <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{item.nomeSocial}})</strong>
                    </template>

                    <template v-else>
                        ({{item.nomeSocial}})
                    </template>
                </template>

                <span
                    v-if="item.bloqueado"
                    class="ml-1"
                    title="Cadastro bloqueado"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="ban" />
                </span>

                <span
                    v-if="isProvisorioOuTemporario(item)"
                    class="ml-1"
                    title="Paciente provisório/temporário"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="hourglass-half" />
                </span>

                <span
                    v-if="item.classificacaoId == enums.classificacao.OUTRO_MUNICIPIO"
                    class="ml-1"
                    title="Paciente não munícipe"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="map-pin" />
                </span>

                <span
                    v-if="item.semCpfCns"
                    class="ml-1"
                    title="Paciente sem CPF e CNS"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="exclamation-triangle" />
                </span>

                <span
                    v-if="item.responsavelFamiliar"
                    class="ml-1"
                    title="Responsável familiar"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="crown" />
                </span>

                <span
                    v-if="isIdoso(item.dataNascimento)"
                    class="ml-1"
                    title="Idoso"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="blind" />
                </span>

                <span
                    v-if="hasTea(item)"
                    class="ml-1"
                    title="Pessoa com Transtorno do Espectro Autista - TEA"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="infinity" />
                </span>

                <span
                    v-if="hasPcd(item)"
                    class="ml-1"
                    title="Pessoa com Deficiência - PCD"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="wheelchair" />
                </span>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="checkRegister(item)"
                    color="primary"
                    small
                    title="Acessar"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>

            <template #afterTable>
                <div class="my-2">
                    <p class="m-0">
                        <span class="legend-color danger" /> Cadastro bloqueado<br>
                        <span class="legend-color orange" /> Paciente provisório ou temporário<br>
                        <span class="legend-color brown" /> Paciente não munícipe<br>
                        <span class="legend-color warning" /> Paciente sem CPF e CNS
                    </p>
                </div>
            </template>
        </rkm-data-table>

        <ModalSolicitacao ref="ModalSolicitacao" />
    </div>
</template>

<script>

//components
import ModalSolicitacao from './components/solicitacao-lista/Modal'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import deficienciaBase from '@/enums/cadastro/cidadao/deficienciaBase'
import deficiencia from '@/enums/cadastro/cidadao/deficiencia'

// Mixins.
import {repository, error, certificadoDigital} from '@/mixins'

// Moment.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {ModalSolicitacao},
    created() {
        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }

        this.load()
    },
    data: () => ({
        enums: {
            preferenciaNome,
            classificacao,
            subclassificacao,
            deficienciaBase,
            deficiencia,
        },
        fields: [
            {key: 'nome', label: 'Nome (Nome social)', name: 'cidadao.nome', searchable: true, sortable: true},
            {key: 'nomeSocial', label: 'Nome social', name: 'cidadao.nomeSocial', searchable: true, sortable: true, visible: false},
            {key: 'dataNascimento', label: 'Data de nascimento', name: 'cidadao.dataNascimento', searchable: true, sortable: true},
            {key: 'nomeMae', label: 'Nome da mãe', name: 'cidadao.nomeMae', searchable: true, sortable: true},
            {key: 'prontuario', label: 'Prontuário municipal', name: 'paciente.prontuario', searchable: true, sortable: true},
            {key: 'cpf', label: 'CPF', name: 'cidadao.cpf', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cidadao.cns', searchable: true, sortable: true},
            {key: 'totalSolicitacoesPendentes', label: 'Total de solicitações pendentes', name: 'totalSolicitacoesPendentes', sortable: true},
            {key: 'actions', label: 'Ações', name: 'actions', class: 'col-min'},
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.solicitacao.getListData()
                .then(({ data }) => {
                    this.exibirAvisoValidadeCertificadoDigital(data.additionals.dadosCertificadoDigital)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async checkRegister(item) {

            if (item.diasCadastroDesatualizado > 0) {

                let msg = `O cadastro do paciente está desatualizado há <strong>${item.diasCadastroDesatualizado} dia(s)</strong>. Deseja continuar?`

                if (item.enderecoDesatualizadoBloqueado) {

                    msg = `O cadastro do paciente está desatualizado há <strong>${item.diasCadastroDesatualizado} dia(s)</strong>.
                        Endereço do usuário também deve ser atualizado. Deseja continuar?`
                }

                this.showConfirmation(
                    msg,
                    async () => {
                        this.$nextTick().then(() => this.abrirSolicitacao(item))
                    },
                );
            } else {

                this.abrirSolicitacao(item)
            }
        },
        abrirSolicitacao(item) {

            if (item.enderecoDesatualizadoBloqueado) {

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                return
            }

            if (this.isModal) {
                this.$emit('create', item.id)
            } else {
                this.openModal(item)
            }
        },
        openModal(paciente) {

            this.$refs.ModalSolicitacao.open(paciente)
        },
        isProvisorioOuTemporario(item) {

            return item.classificacaoId == this.enums.classificacao.PROVISORIO
                || item.subclassificacaoId == this.enums.subclassificacao.TEMPORARIO
        },
        isIdoso(dataNascimento) {

            return !!dataNascimento && moment().diff(moment(dataNascimento, 'DD/MM/YYYY'), 'years') >= 60
        },
        getDeficienciasBaseIds(item) {

            return item.deficienciasBaseIds
                ? item.deficienciasBaseIds.split(',').map(Number)
                : []
        },
        hasTea(item) {

            return this.getDeficienciasBaseIds(item).includes(this.enums.deficienciaBase.TEA)
                || item.deficienciaId === this.enums.deficiencia.AUTISMO
        },
        hasPcd(item) {

            return this.getDeficienciasBaseIds(item).some(id => id !== this.enums.deficienciaBase.TEA)
                || (!!item.deficienciaId && item.deficienciaId !== this.enums.deficiencia.AUTISMO)
        },
        rowClass(item, type) {

            if (type !== 'row' || !item) {

                return ''
            }

            if (item.bloqueado) {

                return 'table-danger'
            }

            if (this.isProvisorioOuTemporario(item)) {

                return 'table-orange'
            }

            if (item.classificacaoId == this.enums.classificacao.OUTRO_MUNICIPIO) {

                return 'table-brown'
            }

            if (item.semCpfCns) {

                return 'table-warning'
            }

            return ''
        },
    },
    mixins: [repository, error, certificadoDigital],
    props: {
        isModal: { type: Boolean },
    },
}
</script>

<style scoped>
.legend-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 4px;
}

.legend-color.danger {
    background-color: var(--danger);
}

.legend-color.orange {
    background-color: #F28C28;
}

.legend-color.brown {
    background-color: #6F4E37;
}

.legend-color.warning {
    background-color: var(--warning);
}

.solicitacao >>> .table-orange {
    border-color: #ffb067;
    background-color: #ffd7b2;
}

.solicitacao >>> .table-brown {
    border-color: #6F4E37;
    background-color: #D2B48C;
}
</style>